/** @jsx jsx */

import React, { Fragment as _ } from 'react';
import { keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';
import EditMarker from 'components/UI/EditMarker';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { colors } from 'styles/variables';
import Hotspot_CTA from 'assets/Hotspot_CTA.svg';

const { lPink } = colors;

const fadeIn = keyframes`
  from {
    width: 0px;
    height: 0px;
  }
  to {
    width: 100px;
    height: 100px;
  }
`;

const EditWrapper = ({ id, width = 0, height = 0, selected }) => {
  return (
    <div
      css={css`
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        ${selected && 'pointer-events: none;'}
      `}
    >
      <div
        css={css`
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          // width: calc(100% - 10px);
          // height: calc(100% - 10px);

          width: ${width - 10}px;
          height: ${height - 10}px;

          // background: rgba(0, 0, 0, 0.1);
          box-shadow: 0 0 0 1px lightGrey;
          transition: all 0.2s;
          cursor: pointer;

          // animation: ${fadeIn} 0.2s forwards;

          &:hover {
            background: rgba(0, 0, 0, 0);
            box-shadow: 0 0 0 1px ${lPink};
          }

          ${selected &&
            `
          // width: calc(100%);
          // height: calc(100%);

          width: ${width + 10}px;
          height: ${height + 10}px;

          background: none;
          box-shadow: 0 0 0 1px ${lPink};
        
          `}
        `}
        onClick={e => {
          e.stopPropagation();
          if (selected) return;

          setCurrentBlock({ id });
        }}
      >
        {!selected && (
          <_>
            {/* <img src={Hotspot_CTA} /> */}
            <EditMarker />
          </_>
        )}
      </div>
    </div>
  );
};

export default EditWrapper;
